const ContactScalarFields = [
	'createdAt',
	'eventDate',
	'firstName',
	'lastName',
	'phone',
	'id',
	'status',
	'updatedAt',
	'hasCustomerIntent',
];

const ContactScalarFieldsNoSensitiveInformation = [
	'createdAt',
	'eventDate',
	'firstName',
	'lastName',
	'id',
	'status',
	'updatedAt',
];

export { ContactScalarFields, ContactScalarFieldsNoSensitiveInformation };
